import { combineReducers } from 'redux'
import update from 'immutability-helper'

function dispatchSystems(state = [], action) {
    switch (action.type) {
        case 'RECEIVE_DISPATCH_SYSTEMS':
            return update(state, {
                $set: action.dispatchSystems,
            })
        default:
            return state
    }
}

function allSystems(state = [], action) {
    switch (action.type) {
        case 'RECEIVE_ALL_SYSTEMS':
            return update(state, {
                $set: action.allSystems,
            })
        default:
            return state
    }
}

export const defaultSystemState = {
    dispatchSystems: [],
    allSystems: [],
}
const systemReducer = combineReducers({
    dispatchSystems,
    allSystems,
})

export default systemReducer
